<template>
  <div class="d-flex flex-column">
    <textarea
      v-model="value"
      v-mask="mask"
      :placeholder="placeholder"
      :class="error ? '-error' : ''"
      @input="input"
      @blur="blur"
      class="textarea"
      type="text"
    />
    <span
      v-if="errorText"
      v-text="errorText"
      class="error-text"
    />
  </div>
</template>

<script>
export default {
  name: 'STextArea',
  props: {
    blur: {
      type: Function,
      default: () => {},
    },
    mask: {
      type: String,
      default: '',
    },
    placeholder: String,
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  methods: {
    input ($e) {
      this.$emit('input', $e.target.value)
    },
  },
}
</script>

<style lang="less">
.textarea {
	width: 100%;
	min-height: 45px;
	display: flex;
	align-items: center;
	background-color: #F9F9F9;
	padding: 10px 18px;
	border: none;
	border-radius: 10px;
	font-family: 'Roboto', Arial, sans-serif;
	font-size: 14px;
	color: black;
	line-height: 23px;
	resize: none;

	&.-error {
		border: 1px solid red;
	}

	&::placeholder {
		font-family: 'Roboto', Arial, sans-serif;
		font-size: 14px;
		color: black;
	}
}

.error-text {
	font-size: 11px;
	color: red;
	margin-top: 4px;
}
</style>
